export default "__VITE_ASSET__Bdh9EBcn__"